import { Flex, Icon } from '@chakra-ui/react'
import { Th, Tr } from '../../../../../../components/Table'
import { IoIosArrowDown } from 'react-icons/io'

export function Columns({ orderBy, ordered }) {
  return (
    <Tr>
      <Th py={2} bgColor="#378BBF" w="75px">
        <Flex
          justifyContent="center"
          alignItems="center"
          gap={1}
          onClick={() => orderBy('abertura_order', 'date')}
          cursor="pointer"
        >
          Data proposta Enviada
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={
              ordered?.column === 'abertura_order' &&
                ordered?.direction === 'asc'
                ? 'rotate(180deg)'
                : 'rotate(0)'
            }
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" width="100px">
        Proposta
      </Th>
      <Th py={2} bgColor="#378BBF" width="100px">
        Consultor
      </Th>
      <Th py={2} bgColor="#378BBF" width="42px">
        <Flex
          justifyContent="center"
          alignItems="center"
          gap={1}
          // onClick={() => orderBy('desconto_order')}
          cursor="pointer"
        >
          Valor da Proposta
          {/* <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={
              ordered?.column === 'desconto_order' &&
              ordered?.direction === 'asc'
                ? 'rotate(180deg)'
                : 'rotate(0)'
            }
          /> */}
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" width="147px">
        Itens
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        <Flex
          justifyContent="center"
          alignItems="center"
          gap={1}
          // onClick={() => orderBy('valor_verba', 'desc')}
          cursor="pointer"
        >
          Desconto
          {/* <Icon
            as={IoIosArrowDown}
            transform={
              ordered?.column === 'valor_verba' && ordered?.direction === 'asc'
                ? 'rotate(180deg)'
                : 'rotate(0)'
            }
            transition="transform 0.3s"
          /> */}
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Verba
      </Th>
      <Th py={2} bgColor="#378BBF" w="45px">
        <Flex
          justifyContent="center"
          alignItems="center"
          gap={1}
          onClick={() => orderBy('prazo')}
          cursor="pointer"
        >
          Prazo
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={
              ordered?.column === 'prazo' && ordered?.direction === 'asc'
                ? 'rotate(180deg)'
                : 'rotate(0)'
            }
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Link PDF
      </Th>
    </Tr>
  )
}
